// Admin user configuration
export const ADMIN_USER_ID = '8db4e6e3-9f0a-49b3-815a-b3a104362388';

// Chat configuration constants
export const CHAT_CONFIG = {
  // Maximum number of messages to load initially
  INITIAL_MESSAGE_LIMIT: 50,
  
  // Maximum number of messages to display in badge (shows "99+" if more)
  MAX_BADGE_DISPLAY: 99,
  
  // Realtime subscription channel prefix
  REALTIME_CHANNEL_PREFIX: 'chat_messages',
  
  // Auto-scroll behavior
  AUTO_SCROLL_THRESHOLD: 100, // pixels from bottom
  
  // Message input constraints
  MAX_MESSAGE_LENGTH: 1000,
  
  // Polling interval for fallback when realtime fails (ms)
  POLLING_INTERVAL: 30000,
  
  // Debounce delay for mark as read operations (ms)
  MARK_READ_DEBOUNCE: 500,
} as const;

// Chat window display modes
export const CHAT_MODES = {
  MODAL: 'modal',
  FULLSCREEN: 'fullscreen',
} as const;

// Message status indicators
export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  READ: 'read',
  FAILED: 'failed',
} as const;

// Realtime event types
export const REALTIME_EVENTS = {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export type ChatMode = typeof CHAT_MODES[keyof typeof CHAT_MODES];
export type MessageStatus = typeof MESSAGE_STATUS[keyof typeof MESSAGE_STATUS];
export type RealtimeEvent = typeof REALTIME_EVENTS[keyof typeof REALTIME_EVENTS];
